import { Link } from "react-router-dom"
import { UrlPath } from "utility/routes"

const NoCompany = () => {
  return (
    <div className="card">
      <div className="card-body">
        <h1 className="h3">Endre 1881s visning av din bedrift</h1>
        <p>Legg til bedrift for endring av opplysninger. Du må ha eierskap eller tillatelse på vegne av bedriften til å endre opplysninger.</p>
        <p className="mt-4">
          <Link to={UrlPath.MyAccount.AddCompany} className="btn btn-primary">
            <i className="bi bi-plus-lg"></i> Legg til  bedrift
          </Link>
        </p>    
      </div> 
    </div>
  )
}

export default NoCompany